import { render } from "./DataSecurity.vue?vue&type=template&id=c8737170&scoped=true"
import script from "./DataSecurity.vue?vue&type=script&lang=js"
export * from "./DataSecurity.vue?vue&type=script&lang=js"

import "./DataSecurity.vue?vue&type=style&index=0&id=c8737170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8737170"]])

export default __exports__